import MoonLoader from 'react-spinners/MoonLoader';
const DataLoading = () => (
  <div className="d-col m-10 items-center justify-center">
    <MoonLoader color={'#393686'} loading={true} size={33} />
  </div>
);

export default DataLoading;
